export default function formatPrice(price) {
    const parsedPrice = parseFloat(price);

    if (isNaN(parsedPrice)) {
        return 'NaN';
    }

    // Check if the number has no decimal places or has .00
    const hasNoDecimals = parsedPrice % 1 === 0;

    // Format with or without decimals based on the check
    const formattedNumber = hasNoDecimals
        ? parsedPrice.toString()
        : parsedPrice.toFixed(2).replace('.', ',');

    return formattedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €';
}
